'use strict';

function r(r) {
  function e(e, i, a, o) {
    var f = i ? t + e + r.e + i : t + e,
        v = f;

    if (a) {
      var u = ' ' + v + r.m;

      for (var s in a) {
        if (a.hasOwnProperty(s)) {
          var p = a[s];
          !0 === p ? v += u + s : p && (v += u + s + n + p);
        }
      }
    }

    if (void 0 !== o) for (var c = 0, l = o.length; c < l; c++) {
      var y = o[c];
      if (y && 'string' == typeof y.valueOf()) for (var g = y.valueOf().split(' '), d = 0; d < g.length; d++) {
        var h = g[d];
        h !== f && (v += ' ' + h);
      }
    }
    return v;
  }

  var t = r.n || '',
      n = r.v || r.m;
  return function (r, t) {
    return function (n, i, a) {
      return 'string' == typeof n ? Array.isArray(i) ? e(r, n, void 0, i) : e(r, n, i, a) : e(r, t, n, i);
    };
  };
}

Object.defineProperty(exports, '__esModule', {
  value: !0
});
var e = r({
  e: '-',
  m: '_'
});
exports.cn = e, exports.withNaming = r;